export default function Pandas_StudyPlan() {
  return <div>Pandas_StudyPlan</div>;
}
